import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const ManageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 2.75rem;

  @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 560px) { grid-template-columns: 1fr; }
`;

export const ManageCard = styled(motion.create(Link))`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  background: var(--background-primary);
  border: 2px solid ${(p) => p.$color ? `${p.$color}33` : 'var(--border-color)'};
  border-radius: 14px;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;

  /* Stronger corner glow tinted by the card's accent */
  &::before {
    content: '';
    position: absolute;
    top: -40%;
    right: -25%;
    width: 60%;
    height: 80%;
    background: radial-gradient(circle, ${(p) => p.$tint || 'transparent'} 0%, transparent 70%);
    opacity: 0.8;
    pointer-events: none;
    transition: opacity 0.25s ease;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    border: 2px solid transparent;
    pointer-events: none;
    transition: border-color 0.2s ease;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15), 0 0 0 2px ${(p) => p.$color || 'var(--primary-color)'};
    border-color: ${(p) => p.$color || 'var(--primary-color)'};
    background: ${(p) => p.$tint ? `${p.$tint}55` : 'var(--background-primary)'};
  }
  &:hover::before { opacity: 1; }
  &:hover::after { border-color: ${(p) => p.$color ? `${p.$color}33` : 'transparent'}; }
  &:hover ${'.manage-arrow'} { color: ${(p) => p.$color || 'var(--primary-color)'}; transform: translateX(2px); }
`;

export const ManageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`;

export const ManageIcon = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${(p) => p.$tint || 'rgba(184, 149, 106, 0.14)'};
  color: ${(p) => p.$color || 'var(--primary-color)'};
  transition: transform 0.2s ease;
  font-weight: 600;

  ${ManageCard ? `` : ''} /* keep arg shape */
`;

export const ManageStat = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

export const ManageTitle = styled.h3`
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.015em;
`;

export const ManageDesc = styled.p`
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.55;
  color: var(--text-muted);
  font-weight: 500;
  flex: 1;
`;

export const ManageFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  color: var(--primary-color);
  font-size: 0.8125rem;
  font-weight: 500;
  transition: color 0.18s ease, gap 0.18s ease;

  ${ManageCard}:hover & { gap: 0.625rem; }
`;

/* ---------- Tools (compact footer-style row) ---------- */

